const artsAndCrafts =
  'https://images.ctfassets.net/wmwzystk5o45/6tSohzw4f03M6EoxodMMCl/be87e2a79f46d5ad9149665976060403/ArtsCrafts_Painting.jpg';
const education =
  'https://images.ctfassets.net/wmwzystk5o45/5hgSrbkHGWb4OCjCxu6iiu/8ea56d8e1ff0813743373cbe594ba2f1/Education_General.jpg';
const food = 'https://images.ctfassets.net/wmwzystk5o45/3gjEmYxmFz7ZWgEjFWQBM1/29054808dde75dcb2a0c44e2f993aca2/Food_Baking.jpg';
const outdoors =
  'https://images.ctfassets.net/wmwzystk5o45/1isFUankK3VJ1UZhGW3dNK/dd86cbecd3dbcb9e8af2ed8f89dacffe/Outdoors_Gardening.jpg';
const performingArts =
  'https://images.ctfassets.net/wmwzystk5o45/72Dbz0ighYyjmefbfo8fkD/df977f60f30da350ed535fbc6e0e60da/PerformingArts_Acting.jpg';
const sports =
  'https://images.ctfassets.net/wmwzystk5o45/6N5JxcTx4ZgUpEsRMSruMz/d1af89cbcc4be226140a8abaa6b8d1f1/Sports_General.jpg';
const stem = 'https://images.ctfassets.net/wmwzystk5o45/4UZTMDazlbFRiBSYcdZHUQ/0d267a077d84f61af5a5a633d785237c/STEM_General.jpg';

export type ExampleAdventure = {
  title: string;
  adventureCategoryImage: { url: string };
  sitterFirstName: string;
  sitterLastInitial: string;
  sitterLocation: {
    cityname: string;
    stateabbr: string;
  };
  sitterMilesWillingToTravel: number;
  sitterAvailability: any;
  minPayRate: number;
  maxPayRate: number;
  duration: number;
  surcharge: number;
  adventureCategoryName: string;
  ageRangeText: string;
  description: string;
  sitterPassion: string;
  adventureSitterSupplies: { item: string }[];
  adventureParentSupplies: { item: string }[];
  status: string;
};

const sitterAvailability: any = {
  monday: ['morning'],
  tuesday: ['afternoon'],
  wednesday: ['evening'],
  thursday: ['morning'],
  friday: ['afternoon'],
  saturday: ['evening'],
  sunday: ['morning'],
};

export const exampleAdventures: ExampleAdventure[] = [
  {
    adventureCategoryImage: { url: artsAndCrafts },
    title: 'Paint a watercolor story',
    sitterFirstName: 'Charlie',
    sitterLastInitial: 'F',
    sitterLocation: { cityname: 'Austin', stateabbr: 'TX' },
    sitterMilesWillingToTravel: 15,
    sitterAvailability,
    minPayRate: 1800,
    maxPayRate: 2100,
    duration: 120,
    surcharge: 500,
    adventureCategoryName: 'Arts & Crafts',
    ageRangeText: '6–10',
    description: `In this 2-part Adventure, we’ll be getting creative in multiple ways. 
    First, we’ll have fun with watercolor paints to create pictures of people, places, or 
    animals. While they dry, we’ll talk about all the different parts that make a story. Then 
    we’ll use the pictures as inspiration to write a story. We’ll create a mini-book of their 
    story and I can help to write words or captions, as needed.`,
    sitterPassion: `I’ve worked as a preschool and after-school teacher for 3 years and love working with kids! 
    I do some creative writing in my spare time, so it’s really fun for me to explore writing 
    and reading with the kids I care for. I believe every child is creative, but the way they 
    explore that creativity is unique to them.`,
    adventureSitterSupplies: [
      { item: 'Paper' },
      { item: 'Paint & brushes' },
      { item: 'Paint tablecloth' },
      { item: 'Pencils' },
      { item: 'Colored pencils' },
    ],
    adventureParentSupplies: [
      { item: 'Flat working surface' },
      { item: 'Paintbrush rinse cups' },
      { item: 'Paper towels' },
      { item: 'Paint clothes/apron' },
    ],
    status: 'active',
  },
  {
    adventureCategoryImage: { url: food },
    title: 'Make adorable caterpillar cupcakes',
    sitterFirstName: 'Annie',
    sitterLastInitial: 'O',
    sitterLocation: { cityname: 'Chicago', stateabbr: 'IL' },
    sitterMilesWillingToTravel: 10,
    sitterAvailability,
    minPayRate: 1700,
    maxPayRate: 2000,
    duration: 120,
    surcharge: 800,
    adventureCategoryName: 'Food',
    ageRangeText: '3–5',
    description: `In this Adventure, we’ll be making cupcakes from scratch, but transforming them
    into one giant caterpillar! The simple steps ensure plenty of time to focus on having fun and 
    some sneaky learning. For the younger kids, we’ll focus on the fine motor skills of mixing 
    ingredients and adding decorations. For older kids, we’ll focus on the math of measuring and 
    fine-tuning our frosting skills. Gluten-free recipe available upon request.`,
    sitterPassion: `As a babysitter for 5 years and an amateur baker, some of my favorite moments spent with kids 
    have been while preparing food together. Food is always a great way to connect with someone new 
    and making it always has so many life lessons built into it. I’m excited to spark your child’s 
    curiosity to learn more about something they already love!`,
    adventureSitterSupplies: [
      { item: 'Cupcake recipe' },
      { item: 'All cupcake ingredients' },
      { item: 'Frosting' },
      { item: 'Sprinkles' },
      { item: 'Piping bags' },
      { item: 'Cupcake tin' },
      { item: 'Cupcake liners' },
    ],
    adventureParentSupplies: [
      { item: 'Mixing bowl' },
      { item: 'Wooden spoon' },
      { item: 'Oven' },
      { item: 'Potholder' },
      { item: 'Flat working surface' },
      { item: 'Plates for eating' },
      { item: 'Apron for child (optional)' },
    ],
    status: 'active',
  },
  {
    adventureCategoryImage: { url: sports },
    title: 'Design & compete in balloon olympics',
    sitterFirstName: 'Shara',
    sitterLastInitial: 'L',
    sitterLocation: { cityname: 'Atlanta', stateabbr: 'GA' },
    sitterMilesWillingToTravel: 10,
    sitterAvailability,
    minPayRate: 1600,
    maxPayRate: 1900,
    duration: 60,
    surcharge: 400,
    adventureCategoryName: 'Sports & Exercise',
    ageRangeText: '11+',
    description: `We’ll have a friendly competition and keep our bodies moving with the safest indoor
     sports equipment: balloons! I have a lot of unique challenges that will allow us to move our 
     bodies in silly ways and I can create balloon versions of any sports your child is interested in. 
     I’ll engage kids to assist me in the creative setup of our play space, agreeing on rules and scoring, 
     and break up each event with the winner choosing a song to play while we set up the next one.`,
    sitterPassion: `I really believe in the power of pure fun as an important part of how a child learns and grows. I’ve 
    been a nanny for 3 years and have young nieces and nephews that I love spending time with. Bringing joy 
    to a kid’s day and keeping them active are my favorite things and I love that they’re part of my job.`,
    adventureSitterSupplies: [{ item: 'Balloons' }, { item: 'Music' }],
    adventureParentSupplies: [{ item: 'Open room or yard to play' }],
    status: 'active',
  },
  {
    adventureCategoryImage: { url: performingArts },
    title: 'Perform in a flashlight shadow show',
    sitterFirstName: 'Natalie',
    sitterLastInitial: 'A',
    sitterLocation: { cityname: 'Nashville', stateabbr: 'TN' },
    sitterMilesWillingToTravel: 15,
    sitterAvailability,
    minPayRate: 1500,
    maxPayRate: 1800,
    duration: 60,
    surcharge: 400,
    adventureCategoryName: 'Sports & Exercise',
    ageRangeText: '11+',
    description: `We’re adding additional performers to our show by including our shadows! By way of 
    flashlights, we’ll experiment with what kind of shapes we can make with our shadows against a blank sheet. 
    Once we’ve warmed up, we’ll work together to create a mini play together to make our shadows really come 
    to life. We can film it so the family can watch it later or be ready for a live performance when you return 
    home.`,
    sitterPassion: `I’ve been doing various theatre shows ever since I was a kid. I was pretty shy in social situations, but 
    the stage gave me a safe space to express myself. I love being able to provide that same opportunity for 
    kids. I see myself in them so much.`,
    adventureSitterSupplies: [{ item: 'Flashlights' }, { item: 'Power strip' }, { item: 'Giant sheet' }, { item: 'Music' }],
    adventureParentSupplies: [{ item: 'Open wall' }, { item: 'Electrical outlet' }],
    status: 'active',
  },
  {
    adventureCategoryImage: { url: stem },
    title: 'Take on the penny zipline challenge',
    sitterFirstName: 'Katie',
    sitterLastInitial: 'N',
    sitterLocation: { cityname: 'Minneapolis', stateabbr: 'MN' },
    sitterMilesWillingToTravel: 20,
    sitterAvailability,
    minPayRate: 1500,
    maxPayRate: 1700,
    duration: 60,
    surcharge: 200,
    adventureCategoryName: 'STEM',
    ageRangeText: '6–10',
    description: `With a string running from one side of the room to the other and a collection of assorted 
    materials, our challenge will be to create a vessel to transport a penny from one end of the zipline to 
    the other. It may take many revisions before success. Little engineers will love the excitement of building 
    an indoor zipline all while practicing great critical thinking and problem-solving skills. We can up the 
    challenge by adding some additional tasks, like a Rube Goldberg machine.`,
    sitterPassion: `I’ve been a babysitter for 3 years and curiosity has been within every child I’ve ever cared for. It’s 
    exciting to me to help nurture that curiosity and find the fulfillment and excitement that can come from 
    that. Kids just love life. They’re so fun!`,
    adventureSitterSupplies: [{ item: 'String' }, { item: 'Penny' }, { item: 'Assorted materials' }],
    adventureParentSupplies: [{ item: 'Open room' }],
    status: 'active',
  },
  {
    adventureCategoryImage: { url: education },
    title: 'Solve riddles to find hidden treasure',
    sitterFirstName: 'Dylan',
    sitterLastInitial: 'L',
    sitterLocation: { cityname: 'New York', stateabbr: 'NY' },
    sitterMilesWillingToTravel: 5,
    sitterAvailability,
    minPayRate: 1900,
    maxPayRate: 2300,
    duration: 60,
    surcharge: 800,
    adventureCategoryName: 'Education',
    ageRangeText: '11+',
    description: `Calling Sherlock Holmes! Solve my series of riddles and puzzles to unlock a hidden treasure 
    somewhere in the house. My game of riddles can be adjusted to challenge the young investigator in certain 
    areas, or can cover a variety. I have options of what the hidden treasure could be, but can also work with 
    the parents on that as well. For an extended time together, after solving my riddles, we’ll work together 
    so that the investigator can create their own puzzle of clues.`,
    sitterPassion: `As a teacher for 3 years and a babysitter for 5 years, I’ve realized that so much learning happens outside 
    of what we traditionally think of as teaching. I love coming up with creative ways to challenge kids’ brains, 
    especially when they don’t even realize it. Many kids do love to learn, it just might look different.`,
    adventureSitterSupplies: [{ item: 'All Clues & Puzzles' }, { item: 'Supplies To Make New Clues' }],
    adventureParentSupplies: [{ item: 'The Hidden Treasure' }],
    status: 'active',
  },
  {
    adventureCategoryImage: { url: outdoors },
    title: 'Start your own mini greenhouse garden',
    sitterFirstName: 'Casey',
    sitterLastInitial: 'V',
    sitterLocation: { cityname: 'Sacramento', stateabbr: 'CA' },
    sitterMilesWillingToTravel: 15,
    sitterAvailability,
    minPayRate: 1700,
    maxPayRate: 2000,
    duration: 60,
    surcharge: 400,
    adventureCategoryName: 'Outdoors',
    ageRangeText: '6–10',
    description: `We’ll be recycling some plastic food containers to help create a mini greenhouse garden! We’ll 
    start by decorating our plant pots. We’ll then create and decorate the greenhouse from plastic containers. 
    Then we’ll get to work planting the seeds in soil and getting them some water and sun. You’ll have the option 
    of planting flowers, vegetables, or a combination of both. We’ll also be creating a personalized watering 
    calendar to make sure the seeds grow big and beautiful.`,
    sitterPassion: `I’ve been a nanny for only a year, but what I lack in experience I make up for in excitement for helping 
    families and seeing kids grow! I love figuring out what excites them and help them find more of that happiness 
    wherever I can!`,
    adventureSitterSupplies: [
      { item: 'Pots' },
      { item: 'Soil' },
      { item: 'Seeds' },
      { item: 'Decoration supplies' },
      { item: 'Plastic containers' },
    ],
    adventureParentSupplies: [{ item: 'Flat surface' }, { item: 'Water source' }],
    status: 'active',
  },
];

export const createFlowExamples = [
  {
    title: 'Paint a watercolor story',
    category: 'Arts & Crafts',
    description:
      'In this 2-part Adventure, we’ll be getting creative in multiple ways. First, we’ll have fun with watercolor paints to create pictures of people, places, or animals. While they dry, we’ll talk about all the different parts that make a story. Then we’ll use the pictures as inspiration to write a story. We’ll create a mini-book of their story and I can help to write words or captions, as needed.',
    passion:
      'I’ve worked as a preschool and after-school teacher for 3 years and love working with kids! I do some creative writing in my spare time, so it’s really fun for me to explore writing and reading with the kids I care for. I believe every child is creative, but the way they explore that creativity is unique to them.',
    ageRangeText: '6-10',
    minPayRate: 1800,
    maxPayRate: 2100,
    adventureCategoryImage: { url: artsAndCrafts },
  },
  {
    title: 'Make adorable caterpillar cupcakes',
    category: 'Food',
    description:
      'In this Adventure, we’ll be making cupcakes from scratch, but transforming them into one giant caterpillar! The simple steps ensure plenty of time to focus on having fun and some sneaky learning. For the younger kids, we’ll focus on the fine motor skills of mixing ingredients and adding decorations. For older kids, we’ll focus on the math of measuring and fine-tuning our frosting skills. Gluten-free recipe available upon request.',
    passion:
      'As a babysitter for 5 years and an amateur baker, some of my favorite moments spent with kids have been while preparing food together. Food is always a great way to connect with someone new and making it always has so many life lessons built into it. I’m excited to spark your child’s curiosity to learn more about something they already love!',
    ageRangeText: '3-5',
    minPayRate: 1700,
    maxPayRate: 2000,
    adventureCategoryImage: { url: food },
  },
  {
    title: 'Design & compete in balloon olympics',
    category: 'Sports & Exercise',
    description:
      'We’ll have a friendly competition and keep our bodies moving with the safest indoor sports equipment: balloons! I have a lot of unique challenges that will allow us to move our bodies in silly ways and I can create balloon versions of any sports your child is interested in. I’ll engage kids to assist me in the creative setup of our play space, agreeing on rules and scoring, and break up each event with the winner choosing a song to play while we set up the next one.',
    passion:
      'I really believe in the power of pure fun as an important part of how a child learns and grows. I’ve been a nanny for 3 years and have young nieces and nephews that I love spending time with. Bringing joy to a kid’s day and keeping them active are my favorite things and I love that they’re part of my job.',
    ageRangeText: '11+',
    minPayRate: 1600,
    maxPayRate: 1900,
    adventureCategoryImage: { url: sports },
  },
  {
    title: 'Perform in a flashlight shadow show',
    category: 'Performing Arts',
    description:
      'We’re adding additional performers to our show by including our shadows! By way of flashlights, we’ll experiment with what kind of shapes we can make with our shadows against a blank sheet. Once we’ve warmed up, we’ll work together to create a mini play together to make our shadows really come to life. We can film it so the family can watch it later or be ready for a live performance when you return home.',
    passion:
      'I’ve been doing various theatre shows ever since I was a kid. I was pretty shy in social situations, but the stage gave me a safe space to express myself. I love being able to provide that same opportunity for kids. I see myself in them so much.',
    ageRangeText: '6-10',
    minPayRate: 1500,
    maxPayRate: 1800,
    adventureCategoryImage: { url: performingArts },
  },
  {
    title: 'Take on the penny zipline challenge',
    category: 'STEM',
    description:
      'With a string running from one side of the room to the other and a collection of assorted materials, our challenge will be to create a vessel to transport a penny from one end of the zipline to the other. It may take many revisions before success. Little engineers will love the excitement of building an indoor zipline all while practicing great critical thinking and problem-solving skills. We can up the challenge by adding some additional tasks, like a Rube Goldberg machine.',
    passion:
      'I’ve been a babysitter for 3 years and curiosity has been within every child I’ve ever cared for. It’s exciting to me to help nurture that curiosity and find the fulfillment and excitement that can come from that. Kids just love life. They’re so fun!',
    ageRangeText: '6-10',
    minPayRate: 1500,
    maxPayRate: 1700,
    adventureCategoryImage: { url: stem },
  },
  {
    title: 'Solve riddles to find hidden treasure',
    category: 'Education',
    description:
      'Calling Sherlock Holmes! Solve my series of riddles and puzzles to unlock a hidden treasure somewhere in the house. My game of riddles can be adjusted to challenge the young investigator in certain areas, or can cover a variety. I have options of what the hidden treasure could be, but can also work with the parents on that as well. For an extended time together, after solving my riddles, we’ll work together so that the investigator can create their own puzzle of clues.',
    passion:
      'As a teacher for 3 years and a babysitter for 5 years, I’ve realized that so much learning happens outside of what we traditionally think of as teaching. I love coming up with creative ways to challenge kids’ brains, especially when they don’t even realize it. Many kids do love to learn, it just might look different.',
    ageRangeText: '11+',
    minPayRate: 1900,
    maxPayRate: 2300,
    adventureCategoryImage: { url: education },
  },
  {
    title: 'Start your own mini greenhouse garden',
    category: 'Outdoors',
    description:
      'We’ll be recycling some plastic food containers to help create a mini greenhouse garden! We’ll start by decorating our plant pots. We’ll then create and decorate the greenhouse from plastic containers. Then we’ll get to work planting the seeds in soil and getting them some water and sun. You’ll have the option of planting flowers, vegetables, or a combination of both. We’ll also be creating a personalized watering calendar to make sure the seeds grow big and beautiful.',
    passion:
      'I’ve been a nanny for only a year, but what I lack in experience I make up for in excitement for helping families and seeing kids grow! I love figuring out what excites them and help them find more of that happiness wherever I can!',
    ageRangeText: '6-10',
    minPayRate: 1700,
    maxPayRate: 2000,
    adventureCategoryImage: { url: outdoors },
  },
];
